import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { Company } from 'shared-pages/common/constants';

export const exportColumns = (t) => {
  return [
    // { fieldName: "id", fieldTitle: "Id", fieldType: "TEXT" },
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'docPrefix', fieldTitle: t('Πρόθεμα Σειράς'), fieldType: 'TEXT' },
    { fieldName: 'name', fieldTitle: t('Περιγραφή Σειράς'), fieldType: 'TEXT' },

    { fieldName: 'startNumber', fieldTitle: t('Αριθμός Έναρξης'), fieldType: 'TEXT' },
    { fieldName: 'endNumber', fieldTitle: t('Αριθμός Λήξης'), fieldType: 'TEXT' },
    {
      fieldName: 'edocSeriesNumbers[0].lastCode',
      fieldTitle: t('Τελευταίος Κωδικός'),
      fieldType: 'TEXT',
    },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      console.log('data', data);
      const recs = data.getEdocSeries.data.map((values) => {
        return {
          ...values,
        };
      });
      const trsData = {
        getEdocSeries: { data: recs, recordCount: data?.getEdocSeries?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export edoc series',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
